document.addEventListener("click", (event) => {
    if (event.target.closest(".weiter_button")) {
        const registrationUser = event.target.closest(".registration_user");
        const registrationOrganisation = event.target.closest("form").querySelector(".registration_organisation");

        registrationUser.classList.add("hidden");
        registrationOrganisation.classList.remove("hidden");
    }

    if (event.target.closest(".zurueck_button")) {
        const registrationOrganisation = event.target.closest(".registration_organisation");
        const registrationUser = event.target.closest("form").querySelector(".registration_user");

        registrationOrganisation.classList.add("hidden");
        registrationUser.classList.remove("hidden");
    }
});
